/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  getApi,
  postApi,
  deleteApi,
} from '@services/agent-foundation/agent-foundation-api-service';

export function getDeployments(queryParams?: Record<string, any>) {
  let queryString = '';
  if (queryParams) {
    const paramsArr = Object.entries(queryParams).flatMap(([key, value]) => {
      if (Array.isArray(value)) {
        return value.map((v) => `${encodeURIComponent(key)}=${encodeURIComponent(v)}`);
      }
      return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
    });
    queryString = paramsArr.length ? `?${paramsArr.join('&')}` : '';
  }
  return getApi(`/agent-garden/deployments${queryString}`);
}
export function getBulkDeployments(endpointUrl: string, deploymentIds: any[]) {
  const apiUrl = '/agent-garden/deployments/bulk-retrieve';
  return postApi(apiUrl, deploymentIds);
}
// Deploy package to environment

export function deployPackage(agentId: string, payload: {
  package_id: string;
  environment_id: string;
}) {
  const apiUrl = `/agent-garden/agents/${agentId}/deployments`;
  return postApi(apiUrl, payload);
}

// List deployments for agent

export function getAgentDeployments(agentId: string, queryParams?: Record<string, any>) {
  const apiUrl = `/agent-garden/agents/${agentId}/deployments`;

  const queryString = queryParams
    ? `?${
      Object.entries(queryParams)
        .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
        .join('&')}`
    : '';
  return getApi(`${apiUrl}${queryString}`);
}

export function getPackageDeployments(packageId: string, queryParams?: Record<string, any>) {
  const apiUrl = `/agent-garden/packages/${packageId}/deployments`;
  const queryString = queryParams
    ? `?${
      Object.entries(queryParams)
        .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
        .join('&')}`
    : '';
  return getApi(`${apiUrl}${queryString}`);
}
// Get deployment details

export function getDeployment(agentId: string, deploymentId: string) {
  const apiUrl = `/agent-garden/agents/${agentId}/deployments/${deploymentId}`;
  return getApi(apiUrl);
}

// Delete deployment

export function deleteDeployment(agentId: string, deploymentId: string) {
  const apiUrl = `/agent-garden/agents/${agentId}/deployments/${deploymentId}`;
  return deleteApi(apiUrl);
}

export function enableDeployment(agentId: string, deploymentId: string) {
  const apiUrl = `/agent-garden/agents/${agentId}/deployments/${deploymentId}/enable`;
  return postApi(apiUrl, {});
}

export function disableDeployment(agentId: string, deploymentId: string) {
  const apiUrl = `/agent-garden/agents/${agentId}/deployments/${deploymentId}/disable`;
  return postApi(apiUrl, {});
}
